export class SumAssuredDetails {
  SumAssured: number;
  SumAssuredValue: number;
  PolicyTypeId: number;
  Premium: number;
  PremiumYearId: number;
  PolicyType: string;
  PremiumYear: string;
  editEnable: boolean;
}

